import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { ApiListResponse, ApiResponse } from '../api';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class GadgetApiService extends ApiService<any> {
  static readonly GADGET_SEARCH_FIELDS = ['name', 'id'];

  constructor(
    protected httpClient: HttpClient,
    private companyStateService: CompanyStateService,
  ) {
    super(httpClient);
  }

  override getResourceUrl(): string {
    return '/v2/gadgets';
  }

  private _createSearchQuery(fields, search) {
    var query = '';

    for (var i in fields) {
      query += 'OR ' + fields[i] + ':~\"' + search + '\" ';
    }

    query = query.substring(3);

    return query.trim();
  }

  private _createQuery(field, ids) {
    var query = '';

    for (var i in ids) {
      query += 'OR ' + field + ":'" + ids[i] + "' ";
    }

    query = query.substring(3);

    return query.trim();
  }

  list(search, cursor?: string): Promise<ApiListResponse<any>> {
    var query = search.query
      ? this._createSearchQuery(
          GadgetApiService.GADGET_SEARCH_FIELDS,
          search.query,
        )
      : '';

    query += search.ids ? this._createQuery('id', search.ids) : '';
    query += search.productCodes
      ? this._createQuery('productCode', search.productCodes)
      : '';

    const params = new HttpParams()
      .set('companyId', this.companyStateService.getSelectedCompanyId())
      .set('search', query)
      .set('cursor', cursor)
      .set('count', search.count)
      .set('sort', search.sortBy + (search.reverse ? ' desc' : ' asc'));

    return firstValueFrom(super.listAsObservable(params));
  }

  get(gadgetId?: string): Promise<ApiResponse<any>> {
    return firstValueFrom(super.getAsObservable(gadgetId));
  }
}
